module.exports = __webpack_public_path__ + "top_page/img-novelty-item-93e98436111e5bf4040a31b25ceb7a89.png";